import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthJWTService } from './jwt/auth-jwt.service';

@Injectable()
export class AuthGuardExternalUser implements CanActivate, CanActivateChild {

  constructor(
      public authService: AuthService,
      private authJwtService: AuthJWTService,
      private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.authJwtService.isAuthenticated()) {
      // console.log('is ExternalUser', this.authService.isExternalUser());
      return this.authService.isExternalUser();
    } else {
      localStorage.removeItem('userToken');
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return this.authService.isAuthenticated();
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // console.log('is authenticated', this.authJwtService.isAuthenticated());
    if (this.authJwtService.isAuthenticated()) {
      return this.authService.isExternalUser();
    } else {
      localStorage.removeItem('userToken');
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return this.authService.isAuthenticated();
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/core/auth/auth-guard-externalUser.service.ts